// A UUID that also exists outside a secure context (TAS-402).
//
// crypto.randomUUID is defined only on https:// and localhost. Open the dev
// server on a LAN address to test on a real phone — http://192.168.x.x:5174 —
// and it is simply missing, so every unguarded call throws: analytics init
// died before Mixpanel loaded, and the join token could not be minted at all,
// which is the one that stops a player joining.
//
// crypto.getRandomValues has no such restriction, so the fallback is a real
// version-4 UUID with the same 122 bits of randomness — this is not a weaker
// token, just one assembled by hand. The last resort exists only so a browser
// without WebCrypto at all degrades instead of throwing; nothing we ship runs
// there, and a join token minted that way is still unguessable enough for a
// value that lives for one evening.

export function randomUUID() {
  const webcrypto = globalThis.crypto;

  if (typeof webcrypto?.randomUUID === 'function') {
    return webcrypto.randomUUID();
  }

  if (typeof webcrypto?.getRandomValues === 'function') {
    const bytes = webcrypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    return (ch === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export default randomUUID;
